<template>
  <div class="relative inline-block text-left">
    <div class="flex items-center">
      <button
        @click="isOpen = !isOpen"
        type="button"
        class="inline-flex items-center capitalize text-xs font-semibold text-gray-600 bg-white rounded-full leading-none px-2 py-1 lg:text-xs"
      >
        {{ assigneeName }}
        <svg
          class="-mr-1  h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clip-rule="evenodd"
          />
        </svg>
      </button>
    </div>

    <transition
      enter-active-class="transition ease-out duration-100 transform"
      enter-class="opacity-0 scale-95"
      enter-to-class="opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75 transform"
      leave-class="opacity-100 scale-100"
      leave-to-class="opacity-0 scale-95"
    >
      <div
        class="origin-top-right absolute left-0 mt-2 w-56 rounded-md shadow-lg z-10"
        v-show="isOpen"
      >
        <div
          class="rounded-md bg-white shadow-xs"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="options-menu"
        >
          <div class="py-1">
            <a
              class="block px-4 py-2 text-xs leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
              role="menuitem"
              @click="onItemClicked(1)"
              >Anyone
            </a>
            <a
              v-for="user in users"
              :key="user.id"
              class="block px-4 py-2 text-xs leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
              role="menuitem"
              @click="onItemClicked(user.id)"
              >{{ user.firstName }} {{ user.lastName }}
            </a>
          </div>
          <div class="border-t border-gray-100"></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "AssigneeDropdown",
  props: {
    assignee: {
      type: String
    }
  },
  data() {
    return {
      isOpen: false,
      tags: []
    };
  },
  computed: {
    users() {
      const users = this.$store.getters["Inbox/getUsers"];
      console.log(users);
      return users;
    },
    assigneeName() {
      return this.$store.getters["Inbox/getUserNameById"](this.assignee);
    }
  },
  created() {
    window.addEventListener("click", this.handleOutsideClick);
  },
  beforeDestroy() {
    window.removeEventListener("click", this.handleOutsideClick);
  },
  methods: {
    handleOutsideClick(e) {
      // close dropdown when clicked outside
      if (!this.$el.contains(e.target)) {
        this.dropDropdown = false;
        this.isOpen = false;
      }
    },
    onItemClicked(userId) {
      this.$emit("onItemClicked", userId);
      this.isOpen = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
